var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraekfrge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#0072bc"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.819,11.627a.826.826,0,0,1-.623-.286,1.46,1.46,0,0,0-2.1,0,.826.826,0,0,1-1.25,0,1.461,1.461,0,0,0-2.1,0,.828.828,0,0,1-1.253,0,1.465,1.465,0,0,0-2.1,0,.835.835,0,0,1-.627.286.322.322,0,1,0,0,.644,1.457,1.457,0,0,0,1.05-.444.831.831,0,0,1,1.254,0,1.46,1.46,0,0,0,2.1,0,.829.829,0,0,1,1.252,0,1.458,1.458,0,0,0,2.1,0,.827.827,0,0,1,1.249,0,1.456,1.456,0,0,0,1.048.445.322.322,0,0,0,0-.644Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.886,7.426,8.367,7.4l-.012-.06.163-1.517L10.62,7a.43.43,0,0,0,.6-.119.375.375,0,0,0-.119-.547l-2.78-1.9A.42.42,0,0,0,8.1,4.357L6.946,4.293a.39.39,0,0,0-.226.05L4.942,5.349a.428.428,0,0,0-.211.491l.223.912c.052.191.152.317.341.317a.445.445,0,0,0,.113-.015.4.4,0,0,0,.253-.527l-.036-.582.751-.324L6.311,7.159l-.043.235-4.56-.019h0a.322.322,0,0,0,0,.644l2.654.011v2.224c.032,0,.056-.01.089-.01a1.565,1.565,0,0,1,1.12.471.724.724,0,0,0,1.112,0,1.567,1.567,0,0,1,2.24,0,.72.72,0,0,0,1.108,0,1.569,1.569,0,0,1,1.12-.471c.031,0,.054.008.084.01v-2.2l2.65.011h0a.322.322,0,0,0,0-.644Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.662,4.077A.779.779,0,1,0,6.883,3.3.778.778,0,0,0,7.662,4.077Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraekfrge);
export default __webpack_public_path__ + "static/media/TRAEKFÆRGE.a3e78c6d49802c52fc8ffdcff637e0c2.svg";
export { ForwardRef as ReactComponent };